export default "__VITE_ASSET__9157f62f__"